import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ProveedorDto } from '../models/proveedores.dto';

@Injectable({
  providedIn: 'root'
})
export class ProveedoresService {
 private apiUrl = ``;
  private entity = `proveedores`;

  constructor(private http: HttpClient) {

    if (environment.production)
      this.apiUrl = environment.apiUrl + this.entity;
    else
      this.apiUrl = environment.apiUrlDev + this.entity;

  } 

 getProveedor(): Observable<ProveedorDto> {
    return this.http.get<ProveedorDto>(this.apiUrl);
 }

}
